module.exports = __webpack_public_path__ + "img/kh.5a13865d.svg";